import FloorPlanNormalizedDataCore from '../FloorPlan/FloorPlanNormalizedDataCore';

const JSONAPIDeserializer = require( 'jsonapi-serializer' ).Deserializer;

const FloorPlansNormalizedData = async ( responseData ) => {
  const options = {
    keyForAttribute: 'camelCase',
  };

  const deserializedData = await new JSONAPIDeserializer( options ).deserialize( responseData );
  const included = responseData?.included;

  const floorPlans = deserializedData?.map( ( deserializedFloorPlan ) => {
    return FloorPlanNormalizedDataCore( deserializedFloorPlan, included );
  } );

  return floorPlans;
};

export default FloorPlansNormalizedData;
